import { gql } from '@apollo/client';
import client from 'graphql/client';

const mutateUserLocaleGraphql = (payload) => {
  const params = {};
  const { variables } = payload;

  if (payload.recache) {
    params.fetchPolicy = 'network-only';
  }

  const mutation = gql`
    mutation changeUserLocale($locale: EmployerLocale!) {
      changeUserLocale(locale: $locale)
    }
  `;

  return client.mutate({
    mutation,
    variables,
    ...params,
  });
};

export default mutateUserLocaleGraphql;
